<div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">

  <mat-tab-group style="width: 100%; background: white;padding-bottom: 60px;">
  <mat-tab label="{{'DISPATCH.ENCUESTA_LANZAMIENTO' | translate}}">
    <div fxLayout="column" fxLayoutAlign="center center">
            <h2 style="font-weight:bold; padding-left:20px; text-align:center;">{{'DISPATCH.TEXTO_CONFIRMAR' | translate}}</h2>
             <h3 *ngIf="flag==false" style="font-weight:bold; padding-left:20px; text-align:center;color:red"> {{'DISPATCH.NO_ENVIO_CORREO' | translate}}</h3>
             <h3 *ngIf="flag==true" style="font-weight:bold; padding-left:20px; text-align:center;color:red">{{'DISPATCH.SI_ENVIO_CORREO' | translate}}</h3>
            <ng-container *ngIf="flag==null">
              <div class="p-16"  fxLayout="row" fxLayoutAlign="center center">
                  <div class="h1" > <button mat-raised-button color="primary" (click)="cambioEstatusEnvioCorreos(1);" [disabled]="!colaboradoresCargados">{{'DISPATCH.SI_CONFIRMAR_ENVIO' | translate}} <mat-icon>thumb_up</mat-icon></button></div>
                  <div class="h1" style="margin-left:20px"> <button style="background-color: #0E35F4; color:white" mat-raised-button color="accent" (click)="cambioEstatusEnvioCorreos(2);" [disabled]="!colaboradoresCargados">{{'DISPATCH.NO_CONFIRMAR_ENVIO' | translate}} <mat-icon>thumb_down</mat-icon></button></div>
              </div>
            </ng-container>

            <ng-container *ngIf="flag!=null && pasoCompleto === false ">
              <div class="h1"> <button style="background-color: #0E35F4; color:white" mat-raised-button color="accent" (click)="cambioEstatusEnvioCorreos(3);" >{{'DISPATCH.CHANGE-OPTIONS' | translate}}<mat-icon>email</mat-icon></button></div>
            </ng-container>

            <ng-container *ngIf="flag!=null && pasoCompleto === true ">
              <div class="h1"> <button style="color:white" mat-raised-button color="accent" (click)="validacionPasoCompleto();" [disabled]="colaboradoresCargados">{{'DISPATCH.CHANGE-OPTIONS' | translate}}<mat-icon>email</mat-icon></button></div>
            </ng-container>

            <h4 *ngIf="flag==null" style="font-weight:bold; padding-left:20px; text-align:center;">{{'DISPATCH.EN_CASO' | translate}}</h4>
            <!------- boton  --------->
            </div>
        <!-- </div>
    </div> -->
  </mat-tab>
  <mat-tab label="{{'DISPATCH.ENCUESTA_PILOTO_ENVIO' | translate}}">

    <!--RECORDATORIOS-->
    <!-- <div class="cursoCard" fxFlex="50" fxFlex.gt-xs="50" fxFlex.gt-sm="40" [@animate]="{value:'*',params:{delay:'250ms',y:'25px'}}">
        <div class="course-content" fxLayout="column" fxFlex="1 1 auto">
            <div class="header accent-100" fxLayout="row" fxLayoutAlign="center center">
                <div class="category" fxFlex>
                    {{'DISPATCH.ENCUESTA_PILOTO_ENVIO' | translate}}
                </div>
            </div> -->
            <!--------- PICK DATE ------->
            <div fxLayout="column" fxLayoutAlign="center center">
            <h2 style="padding-left:20px;">{{'DISPATCH.TITULO_PILOTO' | translate}}</h2>
            </div>
            <div class="p-15" fxLayout="column" fxLayoutAlign="start stretch">
              <div fxLayout="column" fxLayoutAlign="center center">
              <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.INSTRUCCION_PILOTO' | translate}}</h3>
              <h3 class="h3 secondary-text" style="font-weight:bold;">{{'DISPATCH.INSTRUCCION_PILOTO2' | translate}}</h3>
              </div>

              <div *ngFor="let correo of correosPilotos; let i = index;" fxLayout="p-15 row" fxLayoutAlign="center center">
                <mat-form-field class="p-5" fxFlex="60">
                  <mat-error>Campo requerido</mat-error>
                  <input type="email" matInput placeholder="{{'DISPATCH.LABEL03' | translate}}" [disabled]="pasoCompleto" [(ngModel)]="correosPilotos[i].email" (blur)="validarDato($event,i)">
                  <mat-icon matSuffix>email</mat-icon>
                </mat-form-field>
                <mat-form-field class="p-5 ml-20" fxFlex="15">
                  <mat-label>{{'DISPATCH.SELLANG' | translate}}</mat-label>
                  <mat-select [(ngModel)]="correosPilotos[i].idioma">
                    <mat-option *ngFor="let idioma of idiomas" [value]="idioma.nombreIdioma">{{'NOMBREIDIOMAS.'+idioma.nombreIdioma | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxLayout="p-15 row" fxLayoutAlign="center center">
                <button mat-raised-button color="accent" (click)="enviaPilotos();" [disabled]="pasoCompleto">{{'DISPATCH.LABEL04' | translate}}</button>
              </div>

            </div>
            <!------- boton  --------->

        <!-- </div>
    </div> -->
  </mat-tab>
 </mat-tab-group>

</div>



<ng-container *ngIf="changeInfoFin">
  <div style="margin: 20px;">
    <!-- <button mat-raised-button color="accent" [routerLink]="'/requirements-detail'">{{'DISPATCH.SEE_TI' | translate}}</button> -->
    <!-------------boton completar paso---------->
    <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
      <button *ngIf="pasoCompleto === false " (click)="completarPaso()" mat-fab aria-label="boton completar paso" matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20" (click)="completarPaso()">
        <mat-icon>done</mat-icon>
      </button>
      <button *ngIf="pasoCompleto === true " (click)="completarPaso()" mat-raised-button class="done mr-20">
        {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
        <mat-icon class="ml-20">done</mat-icon>
      </button>

      <!-- desbloquearPaso -->
      <button *ngIf="pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearEnvioCorreos()" mat-fab aria-label=""
      matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
      >
      <mat-icon>lock_open</mat-icon>
    </button>

    <button *ngIf="!pasoCompleto && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearEnvioCorreos()" mat-raised-button class="reopen mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.UNLOCK' | translate}}
      <!-- <mat-icon class="ml-20">lock_open</mat-icon> -->
    </button>
  </div>

</div>
</ng-container>
